import { Stack, Text } from '@instamenu/ui-system-next';
import {
  CheckoutRestaurantFieldsFragment,
  RestaurantHours,
} from '@instamenu/context-checkout/server';
import { Info } from 'luxon';
import { formatTime } from '@instamenu/formatters';
import { Fragment } from 'react';

export const OpeningHoursTable = (props: { restaurant: CheckoutRestaurantFieldsFragment }) => {
  const { restaurant } = props;
  const hours = new RestaurantHours(restaurant);
  if (!hours.openingHoursThisWeek) return null;
  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: 12, marginTop: 24 }}>
        {hours.openingHoursThisWeek.map((dayHours) => (
          <Fragment key={dayHours.day}>
            <Text variant="caption1">
              {Info.weekdays('long', { locale: 'en' })[dayHours.day - 1]}{' '}
              {dayHours.name ? `(${dayHours.name})` : undefined}
            </Text>
            {dayHours.closed ? (
              <Text variant="caption1" css={{ textAlign: 'right' }}>
                Closed
              </Text>
            ) : (
              <Stack css={{ textAlign: 'right' }}>
                {dayHours.openingPeriods.map((period, index) => (
                  <Text key={index} variant="caption1">
                    {formatTime(period.startTime)} - {formatTime(period.endTime)}
                  </Text>
                ))}
              </Stack>
            )}
          </Fragment>
        ))}
      </div>
    </>
  );
};
